import Request from "../../shared/utils/_request";

class Common {
  constructor() { }
  
  getFuncName(payload) {
    return Request.post("/common/func/search", payload);
  }
  getCityTree() {
    return Request.post("/common/area/get-tree");
  }
  getPostTree() {
    return Request.post("/common/func/get-tree");
  }
  getIndustryTree() {
    return Request.post("/common/industry/get-tree");
  }
  getStaticValues() {
    return Request.post("/common/property/getStaticValues");
  }
  getCompanyList(payload) {
    return Request.post("/common/BusinessData/search", payload);
  }
  searchProducts(payload) {
    return Request.post("/common/BusinessData/searchProducts", payload);
  }
  searchCompanyHr(payload) {
    return Request.post("/company/HrCompanyContacter/get-items", payload);
  }
  /**
   * 积分规则
   */
  getPointRule() {
    return Request.post("/common/user-rules/get-point-rule");
  }
  getIPaddr() {
    return Request.post('/common/property/get-ip')
  }
  // 附加要求
  getSkills(payload) {
    return Request.post('/common/function-skill/getSkill', payload)
  }
  // 获取输入地点定位
  searchAddress(payload) {
    return Request.post('/common/area/getPlaceSuggestion', payload)
  }
  //获取专业
  getmajortree(payload) {
    return Request.post('/common/major/get-tree', payload)
  }
}

export const common = new Common();
